<template>
  <div class="tile is-vertical">
    <div class="card">
      <div class="card-content">
        <div class="content has-text-justified">
          <h2 class="has-text-centered">Introducción</h2>
          <p class="has-text-centered">MUCRISIS es un proyecto que fue creado por un pequeño grupo de desarrolladores con la finalidad de aprender diversos lenguajes y herramientas de programación. Se tomó una versión clásica para empezar, sin embargo, se tiene pensado expandir a versiones avanzadas más adelante, en cuanto se vaya aprendiendo más del funcionamiento interno del juego.</p>
          <p class="has-text-centered">Es un servidor privado de MuOnline, creado sin fines de lucro y por entretenimiento de los mismos desarrolladores del servidor.</p>
          <h3>Especificaciones</h3>
          <p>El servidor se encuentra en fase "Beta Abierta", aún carece de muchas funcionalidades que nos encantaría que tuviese, por los momentos empezaremos abriendo el juego para su disfrute con las siguientes especificaciones:</p>
          <ul>
            <li v-for="(d,n) in details" :key="n">{{d.description}}</li>
          </ul>
          <p class="help">Nota: el servidor todavía se encuentra en pleno desarrollo y poco a poco iremos agregando nuevos contenidos, para sugerencias o incomodidades sugerimos visitar la sección de <router-link to="/contacto"><fa icon="location-arrow" />&nbsp;Contacto</router-link>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'AboutView',
  beforeCreate(){
    this.$store.dispatch('setPage', {
      location:{name:'about',number:3},
      title:'Acerca del servidor',
      breadcrumb:[
        {name:'inicio',link:this.$store.state.baseUrl,active:true, icon:'home'},
        {name:'información',link:'/informacion',active:false, icon:'info-circle'}
      ]
    })
  },
  data:()=>({
    details: [
      {description: 'Versión 97d.'},
      {description: 'Lenguaje Español (Cliente parcialmente traducido).'},
      {description: 'Jugabilidad Medium-Slow.'},
      {description: 'Experiencia 25x.'},
      {description: 'Reset a nivel 500.'},
      {description: 'GrandReset al alcanzar 100 reset.'},
      {description: 'Puntos por Nivel 5 (7 Magic Gladiador).'},
      {description: 'Puntos por Reset 500.'},
      {description: 'Ranking por Nivel, por Gremio (Guild) y por asesinatos (Pks)'},
      {description: 'Comando /move unicamente hacia zonas seguras de los mapas.'},
      {description: 'Cuadrilátero de peleas en Lorencia.'},
      {description: 'Sistema VIP y Créditos.'},
      {description: 'Porcentaje de drop: 60.'},
      {description: 'Sistema de Monstruos Jefes (Bosses) con drops acorde a su dificultad.'},
      {description: 'Eventos: Nativos de la Versión 97d, Blood Castle, Devil Square e invasiones variadas.'},
      {description: 'Eventos unicos diarios: BattleSky, Hora Feliz, Lucky Jewels y Evento de Grupos.'},
      {description: 'Zonas pk libre de costo.'},
      {description: 'Sistema de peleas muy balanceado.'},
      {description: 'Personajes: Elf, Wizard, Knight y Magic Gladiator.'},
      {description: 'Sistema de evolución de personaje normal. Items de evolución unicamente obtenidos por drops en Losttower, Atlans y Tarkan.'},
      {description: 'Jewels: Life, Soul y Bless adquiribles en diversas tiendas o por drops, Chaos unicamente obtenible en BloodCastle.'},
      {description: 'Feather: Unicamente obtenible en drops.'},
      {description: 'Items Excelent: Alto rate en monstruos jefes, muy bajo rate en monstruos normales y 100% en cajas kundun.'},
      {description: 'Cajas Kundun: unicamente obtenibles de invasiones de monstruos dorados o eventos GM.'},
      {description: 'Tienda Web (aún en desarrollo) basado en sistema de Créditos, obtenidos de forma gratis jugando.'},
    ]
  })
}
</script>

<style>

</style>
